module.exports = __webpack_public_path__ + "img/next.3b810b07.svg";